import { http } from '../utils/http';

export function getMeasurements(
    deviceId,
    { startDate, endDate, limit = 20, offset = 0 } = {}
) {
    return http.get(`/devices/${deviceId}/measurements`, {
        params: {
            start_time: startDate || undefined,
            end_time: endDate || undefined,
            limit,
            offset,
        },
    });
}

export function getMeasurementExtremes(
    deviceId,
    { startDate, endDate, signal } = {}
) {
    return http.get(`/devices/${deviceId}/measurements/extremes`, {
        params: {
            start_time: startDate || undefined,
            end_time: endDate || undefined,
        },
        signal,
    });
}

export function getMeasurementsExtremesAll({ startDate, endDate, signal } = {}) {
    return http.get('/measurements/extremes', {
        params: {
            start_time: startDate || undefined,
            end_time: endDate || undefined,
        },
        signal,
    });
}

export function createChartFlow({ deviceName, end, signal, timeout = 60000 } = {}) {
    return http.post(
        '/flow/create_chart_flow',
        {
            device_name: deviceName || undefined,
            end: end || undefined,
        },
        { signal, timeout }
    );
}

export function getDevicesLocations() {
    return http.get('/devices-locations');
}

export function getDeviceInfo(deviceId) {
    return http.get(`/devices/${deviceId}/info`);
}
export function changeAlertManual(deviceId, status, { axis, signal } = {}) {
    const payload = { status };
    if (axis) {
        const axisText = String(axis).trim().toLowerCase();
        const normalizeToken = (value) => {
            if (!value) return '';
            if (value === '13' || value === '1-3' || value === 'x') return '13';
            if (value === '24' || value === '2-4' || value === 'y') return '24';
            return value;
        };
        if (axisText === 'both') {
            payload.axis = 'both';
        } else if (axisText.includes(',') || axisText.includes(' ')) {
            const tokens = axisText
                .split(/[,\s]+/)
                .map((token) => normalizeToken(token.trim()))
                .filter(Boolean);
            const has13 = tokens.includes('13');
            const has24 = tokens.includes('24');
            payload.axis = has13 && has24 ? 'both' : tokens[0];
        } else {
            payload.axis = normalizeToken(axisText);
        }
    }
    return http.put(`/devices/${deviceId}/alert-status/manual`, payload, { signal });
}
